module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project) ? _c('div', {
    staticClass: "project"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col buttons"
  }, [(_vm.project.github) ? _c('a', {
    staticClass: "button",
    attrs: {
      "target": "_blank",
      "href": _vm.project.github
    }
  }, [_vm._v("GitHub Repo")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "target": "_blank",
      "href": _vm.project.url
    }
  }, [_vm._v("Live Site")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col ie11Hack"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  })])])]), _vm._v(" "), _c('nav', [_c('div', {
    staticClass: "container"
  }, [(_vm.previousProject.slug) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "a",
      "to": ("/work/" + (_vm.previousProject.category) + "/" + (_vm.previousProject.slug))
    }
  }, [_vm._v("Previous Project")]) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }), _vm._v(" "), (_vm.nextProject.slug) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "a",
      "to": ("/work/" + (_vm.nextProject.category) + "/" + (_vm.nextProject.slug))
    }
  }, [_vm._v("Next Project")]) : _vm._e()], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "image"
  }, _vm._l((_vm.project.imageListLength), function(n) {
    return _c('li', {
      staticClass: "lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (_vm.project.category) + "/" + (_vm.project.slug) + "/" + (_vm.project.slug) + "-" + n + ".png")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}-${n}.png`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (_vm.project.category) + "/" + (_vm.project.slug) + "/" + (_vm.project.slug) + "-" + n + "@2x.png 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])
  }))]) : _c('Error')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6599fa2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 123
// module chunks = 1